export enum ApuType {
  ARCH_DESC = 'ARCH_DESC',
  COLLECTION = 'COLLECTION',
  ENTITY = 'ENTITY',
  FINDING_AID = 'FINDING_AID',
  FUND = 'FUND',
  INSTITUTION = 'INSTITUTION',
}

export enum ApuPartItemDataType {
  ENUM = 'ENUM',
  APU_REF = 'APU_REF',
  INTEGER = 'INTEGER',
  STRING = 'STRING',
  UNITDATE = 'UNITDATE',
  LINK = 'LINK',
  ITEM_AGGREG = 'ITEM_AGGREG',
  JSON = 'JSON',
}

export enum ApuPartItemEnum {
  ARCHDESC_ROOT_REF = 'ARCHDESC~ROOT~REF',
}

export enum ApuPartViewType {
  GROUPED = 'GROUPED',
  STANDALONE = 'STANDALONE',
}
